module.exports = __webpack_public_path__ + "static/TimesLtPro-SemiboldItalic-7d1304e4af9c0ad922e631332c1bc7ea.woff";